import { Route, Routes } from 'react-router-dom';
import { RefundsPage } from './RefundsPage';
import { UpdateRefundPage } from './UpdateRefundPage';

export const RefundPageRoot = () => (
  <Routes>
    <Route path='/:refundID' element={<UpdateRefundPage />} />
    <Route path='*' element={<RefundsPage />} />
  </Routes>
);
